import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Logout from '@/features/auth/pages/Logout';
import NewPassword from '@/features/auth/pages/NewPassword';
import PageAuthorization from '@/features/auth/pages/PageAuthorization';
import Profile from '@/features/auth/pages/Profile';
import SignIn from '@/features/auth/pages/SignIn';
import Unauthorized from '@/features/auth/pages/Unauthorized';

import VisualizacaoProtocoloEnterprise from '@/features/enterprise/pages/VisualizacaoProtocolo';

import ListaProtocolo from '@/features/dashboard/pages/PageHome';

import AbrirExecucao from '@/features/execucao/pages/AbrirExecucao';
import ExecucaoProtocolo from '@/features/execucao/pages/ExecucaoProtocolo';

import ExecucaoProtocoloEnterprise from '@/features/enterprise/pages/ExecucaoProtocoloEnterprise';
import PageIntegracaoProtocolo from '@/features/enterprise/pages/PageIntegracaoProtocolo';

import SignupScreen from '@/features/auth/pages/SignUp';
import PageProtocolosList from '@/features/dashboard/pages/PageProtocolosList';

import NotFound from '@/pages/not-found';

import withTracker from '@/utils/hooks/withTracker';
import ModuleRoute from './ModuleRoute';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

const Routes: React.FC = () => {
  return (
    <Switch>
      <ModuleRoute
        module="portal"
        path="/"
        exact
        authenticated
        component={withTracker(ListaProtocolo)}
      />

      <ModuleRoute
        module="portal"
        path="/protocolos"
        exact
        authenticated
        component={withTracker(PageProtocolosList)}
      />

      <ModuleRoute
        module="portal"
        path="/perfil"
        exact
        authenticated
        component={withTracker(Profile)}
      />

      <ModuleRoute
        module="portal"
        path="/entrar"
        component={withTracker(SignIn)}
        restricted
      />

      <ModuleRoute
        module="portal"
        path="/cadastro"
        component={withTracker(SignupScreen)}
        restricted
      />

      <ModuleRoute
        module="portal"
        path="/auth/password/reset/confirm/:uid/:token"
        component={withTracker(NewPassword)}
      />

      <PrivateRoute
        path="/enterprise/protocolos/:id/resumo"
        exact
        component={withTracker(VisualizacaoProtocoloEnterprise)}
      />

      <ModuleRoute
        module="enterprise"
        path="/enterprise/protocolos/:id"
        authenticated
        component={withTracker(ExecucaoProtocoloEnterprise)}
      />

      <ModuleRoute
        module="enterprise"
        path="/enterprise/integracoes/:id"
        exact
        authenticated
        component={withTracker(PageIntegracaoProtocolo)}
      />

      <ModuleRoute
        module="enterprise"
        path="/enterprise/authorize/"
        component={withTracker(PageAuthorization)}
      />

      <ModuleRoute
        module="enterprise"
        path="/enterprise/runtime/:session_id/protocolos/:id"
        component={withTracker(ExecucaoProtocoloEnterprise)}
      />

      <PrivateRoute path="/sair" component={withTracker(Logout)} />

      <PrivateRoute
        path="/abrir-execucao"
        component={withTracker(AbrirExecucao)}
      />

      <PublicRoute
        path="/execucao"
        component={withTracker(ExecucaoProtocolo)}
      />

      <PublicRoute path="/unauthorized" component={withTracker(Unauthorized)} />
      <Route path="/not-found" component={withTracker(NotFound)} />
      {/* NotFound routes */}
      <Route path="*">
        <Redirect to="/not-found" />
      </Route>

      {/* <PrivateRouteEnterprise
        path="/protocolos-execucao"
        exact
        component={withTracker(ProtocoloExecutadoList)}
      />
      <PrivateRoute
        path="/calculadoras"
        exact
        component={withTracker(ListaCalculadoras)}
      />
      <PrivateRoute
        path="/calculadoras/:codigo"
        exact
        component={withTracker(Calculadora)}
      />
      <PrivateRoute
        path="/historicos"
        exact
        component={withTracker(PageHistoryList)}
      />
      <PrivateRoute
        path="/historicos/:id"
        exact
        component={withTracker(PageHistoryDetail)}
      />
      <PrivateRoute
        path="/especialidades"
        exact
        component={withTracker(EspecialidadeList)}
      />
      <PrivateRoute
        path="/especialidades/:id"
        exact
        component={withTracker(EspecialidadeProtocoloList)}
      />
      <PrivateRoute path="/perfil" exact component={withTracker(Profile)} />
      <PublicRoute path="/entrar" component={withTracker(SignIn)} restricted />
      <PublicRoute
        path="/cadastro"
        component={withTracker(SignupScreen)}
        restricted
      />
      <PrivateRoute path="/sair" component={withTracker(Logout)} />
      <PrivateRoute
        path="/enterprise/protocolos/:id/resumo"
        exact
        component={withTracker(VisualizacaoProtocoloEnterprise)}
      />
      <PrivateRouteEnterprise
        path="/enterprise/protocolos/:id"
        exact
        component={withTracker(ExecucaoProtocoloEnterprise)}
      />
      <PrivateRouteEnterprise
        path="/enterprise/runtime/:session_id/protocolos/:id"
        exact
        component={withTracker(ExecucaoProtocoloEnterprise)}
      />
      <PrivateRouteEnterprise
        path="/enterprise/protocolos/:id/info"
        exact
        component={withTracker(InfoAtendimentoEnterprise)}
      />
      <PrivateRouteEnterprise
        path="/enterprise/integracoes/:id"
        exact
        component={withTracker(PageIntegracaoProtocolo)}
      />
      <PrivateRoute
        path="/abrir-execucao"
        component={withTracker(AbrirExecucao)}
      />
      <PublicRoute
        path="/execucao"
        component={withTracker(ExecucaoProtocolo)}
      />
      <PublicRoute
        path="/auth/password/reset/confirm/:uid/:token"
        component={withTracker(NewPassword)}
      />
      <PublicRoute
        path="/enterprise/authorize/"
        component={withTracker(PageAuthorization)}
      />
      <PublicRoute path="/unauthorized" component={withTracker(Unauthorized)} />

      {/* NotFound routes */}
      <Route>
        <Redirect to="/" />
      </Route>
    </Switch>
  );
};

export default Routes;
